/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface ParamsProps {
  leads: [
    {
      idLead: string | undefined;
      idLeadCorretor: string | undefined;
      idCorretorLead: string | undefined;
    }
  ];
  idCorretorDestino: string | undefined;
  descricaoMotivoTransferencia: string | undefined;
  transferirTodasPaginas?: boolean;
  idCorretorOrigem?: string;
}

export function useTransferirV1(params: ParamsProps | null) {
  // eslint-disable-next-line no-promise-executor-return
  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));
  const updateData = async () => {
    if (params?.idCorretorDestino === "") {
      toast.warn("Selecione um corretor.");
      return;
    }
    const TRANSFERIR = `${leadsWebEnviroment}/commom/leads/transferir/v1`;
    // Toda a carteira: a API busca os leads pelo corretor de origem, e não pelos
    // ids. Nos demais casos a origem sai de cada lead enviado.
    const body = params?.transferirTodasPaginas
      ? { ...params, leads: undefined }
      : { ...params, idCorretorOrigem: undefined };
    return await instance.put(TRANSFERIR, body);
  };
  const query = useMutation({
    mutationFn: async () => await updateData(),
    mutationKey: ["transferir-lead"],
    onError: (error: any) => {
      toast?.error(
        `Erro ao transferir lead. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
    onSuccess: async () => {
      toast.success("Lead transferido com sucesso.", { autoClose: 10000 });
      await delay(3000);
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    },
  });
  return query;
}
